import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import SystemModal from "../Common/SystemModal";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers";
const UpdateSupplier = ({ SupID, onUpdate, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState(null);
  // Form states
  const [bussName, setBussName] = useState("");
  const [bussContact, setBussContact] = useState("");
  const [bussEmail, setBussEmail] = useState("");
  const [bussTIN, setBussTIN] = useState("");
  const [bussLocation, setBussLocation] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [personContact, setPersonContact] = useState("");
  const [partners, setPartners] = useState([]);
  // Fetch supplier details
  const fetchSupplier = async () => {
    if (!SupID) return;
    setLoading(true);
    const res = await ajaxSuppliers.fetchSuppliersDetails({ supID: SupID });
    setLoading(false);
    if (res?.status === "OK" && res.details) {
      const s = res.details;
      setSupplier(s);
      setBussName(s.buss_name || "");
      setBussContact(s.buss_contact || "");
      setBussEmail(s.buss_email || "");
      setBussTIN(s.TIN || "");
      setBussLocation(s.location || "");
      setContactPerson(s.contact_person || "");
      setPersonContact(s.person_contact || "");
      setPartners(
        s.partners?.map((p) => ({
          id: p.id,
          partner_name: p.partner_name,
          partner_contact: p.partner_contact,
        })) || []
      );
    } else {
      toast.error(res?.message || "Failed to fetch supplier details");
    }
  };
  useEffect(() => {
    fetchSupplier();
  }, [SupID]);
  // Partner handlers
  const handlePartnerChange = (index, field, value) => {
    const updated = [...partners];
    updated[index][field] = value;
    setPartners(updated);
  };
  const handleAddPartner = () => {
    if (partners.length > 0) {
      const last = partners[partners.length - 1];
      if (!last.partner_name || !last.partner_contact) {
        toast.error(
          "Please complete the current partner row before adding a new one."
        );
        return;
      }
    }
    setPartners([...partners, { partner_name: "", partner_contact: "" }]);
  };
  const handleDeletePartner = (index) => {
    const updated = [...partners];
    updated.splice(index, 1);
    setPartners(updated);
  };
  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate partners
    for (let i = 0; i < partners.length; i++) {
      const p = partners[i];
      if (!p.partner_name || !p.partner_contact) {
        toast.error(`Please complete all details for partner ${i + 1}`);
        return;
      }
    }
    const data = {
      supID: SupID,
      buss_name: bussName,
      buss_contact: bussContact,
      buss_email: bussEmail,
      buss_tin: bussTIN,
      buss_location: bussLocation,
      contact_person: contactPerson,
      person_contact: personContact,
      partners: partners,
    };
    const response = await ajaxSuppliers.updateSupplier(data);
    if (response.status === "OK") {
      toast.success(response.message);
      onUpdate?.(); // callback to refresh parent list
      onClose?.(); // close modal
    } else {
      toast.error(response.message);
    }
  };
  if (!SystemModal) return null;
  const RenderFooter = (controls) => (
    <div className="d-flex justify-content-end">
      <button
        className="btn btn-dark me-2"
        type="button"
        onClick={controls?.close || onClose}
      >
        Close
      </button>
      <button
        className="btn btn-primary"
        type="submit"
        form="update-supplier-form"
      >
        Update
      </button>
    </div>
  );
  return (
    <SystemModal
      title="Update Supplier"
      id="modal-update-supplier"
      size="lg"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && (
        <div className="text-center py-5">
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {!loading && supplier && (
        <form id="update-supplier-form" onSubmit={handleSubmit}>
          <div className="row row-sm">
            {/* Left Column */}
            <div className="col-md-6">
              <div className="form-group mb-2">
                <p className="mg-b-10">Business Name</p>
                <input
                  type="text"
                  className="form-control"
                  value={bussName}
                  onChange={(e) => setBussName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-2">
                <p className="mg-b-10">Business Contact</p>
                <PhoneInput
                  country="ug"
                  value={bussContact}
                  onChange={(phone) => setBussContact("+" + phone)}
                  containerStyle={{ width: "100%" }}
                  inputStyle={{
                    width: "100%",
                    fontSize: "1rem",
                    borderRadius: "0.25rem",
                  }}
                  enableSearch
                />
              </div>
              <div className="form-group mb-2">
                <p className="mg-b-10">Business Email</p>
                <input
                  type="email"
                  className="form-control"
                  value={bussEmail}
                  onChange={(e) => setBussEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-2">
                <p className="mg-b-10">Business TIN</p>
                <input
                  type="text"
                  className="form-control"
                  value={bussTIN}
                  onChange={(e) => setBussTIN(e.target.value)}
                  required
                />
              </div>
            </div>
            {/* Right Column */}
            <div className="col-md-6">
              <div className="form-group mb-2">
                <p className="mg-b-10">Business Location</p>
                <input
                  type="text"
                  className="form-control"
                  value={bussLocation}
                  onChange={(e) => setBussLocation(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-2">
                <p className="mg-b-10">Contact Person</p>
                <input
                  type="text"
                  className="form-control"
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-2">
                <p className="mg-b-10">Person Contact</p>
                <PhoneInput
                  country="ug"
                  value={personContact}
                  onChange={(phone) => setPersonContact("+" + phone)}
                  containerStyle={{ width: "100%" }}
                  inputStyle={{
                    width: "100%",
                    fontSize: "1rem",
                    borderRadius: "0.25rem",
                  }}
                  enableSearch
                />
              </div>
            </div>
            {/* Partners Table */}
            <div className="col-md-12 mt-3">
              <h6>Business Partners</h6>
              <table className="table table-bordered table-hover text-nowrap">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Partner Name</th>
                    <th>Partner Contact</th>
                    <th>Operations</th>
                  </tr>
                </thead>
                <tbody>
                  {partners.map((partner, index) => (
                    <tr key={partner.id || index}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={partner.partner_name}
                          onChange={(e) =>
                            handlePartnerChange(
                              index,
                              "partner_name",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <PhoneInput
                          country="ug"
                          value={partner.partner_contact}
                          onChange={(phone) =>
                            handlePartnerChange(
                              index,
                              "partner_contact",
                              "+" + phone
                            )
                          }
                          containerStyle={{ width: "100%" }}
                          inputStyle={{
                            width: "100%",
                            fontSize: "1rem",
                            borderRadius: "0.25rem",
                          }}
                          enableSearch
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDeletePartner(index)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={handleAddPartner}
                      >
                        Add Partner
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      )}
      {!loading && !supplier && (
        <div className="text-center py-5 text-muted">
          No supplier data available.
        </div>
      )}
    </SystemModal>
  );
};
export default UpdateSupplier;
